import React from 'react';
import { I18n } from '@aws-amplify/core';
import FormItem from '@/components/ui/FormItem';
import InputRadio from '@/components/ui/InputRadio';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function EarlyManifestationFormItem({ fieldName = '', required = true }: Readonly<FormItemProps>): JSX.Element {
	return (
		<FormItem
			label="Early manifestation"
			name={fieldName}
			requiredMessage="Please select a early manifestation"
			required={required}
		>
			<InputRadio
				options={[
					{ label: I18n.get('Yes'), value: true },
					{ label: I18n.get('No'), value: false }
				]}
			/>
		</FormItem>
	);
}
